<template>
    <html>
        <body class="ovrflow desk_bckgnd_img_login">
            <header class="desk_display common--header header--overide">
                <b-row class="row_lr_margin">
                    <b-col cols="10" v-if="store.isLogoAvailable">
                        <img :src="store.groupDetail.cssp" alt class="img-responsive-class" style="max-height: 70px" />
                    </b-col>
                    <b-col cols="10" v-if="!store.isLogoAvailable">
                        <p class="app-header-title">{{ store.groupDetail.gnm }}</p>
                    </b-col>
                </b-row>
            </header>
            <div class="college_main_div">
                <b-container class="bv-example-row cont_height mob_col_padding">
                    <b-row align-h="center" class="dev_lr_margin row_height">
                        <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 col_padding dev_position">
                            <b-container class="brand--logo">
                                <b-row>
                                    <b-col cols="2" class="text-left">
                                        <div class="bck-btn">
                                            <b-button type="Back" variant="outline-light" v-on:click="backAction">
                                                <img src="images/back_blue.png" />
                                            </b-button>
                                        </div>
                                    </b-col>
                                    <b-col class="mob-display" cols="8" v-if="store.isLogoAvailable">
                                        <div class="text-center">
                                            <img :src="store.groupDetail.cssp" alt class="img-responsive-class" />
                                        </div>
                                    </b-col>
                                    <b-col class="mob-display" cols="8" v-if="!store.isLogoAvailable">
                                        <div class="text-center">
                                            <p class="init-header-title">{{ store.groupDetail.gnm }}</p>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                            <b-container>
                                <b-row>
                                    <b-col>
                                        <div class="otp_form">
                                            <b-form @submit="onContinue">
                                                <b-container>
                                                    <b-row>
                                                        <b-col>
                                                            <h5 class="title_text_otp">ONE-TIME-PASSWORD VERIFICATION</h5>
                                                        </b-col>
                                                    </b-row>
                                                    <p class="otp_msg textWhiteColor">{{ this.otpMsg }}</p>
                                                    <div>
                                                        <b-row class="justify-content-md-center">
                                                            <b-col lg="4" md="4">
                                                                <input
                                                                    class="otpInputField"
                                                                    type="number"
                                                                    maxlength="4"
                                                                    id="yearField"
                                                                    v-model="form.otp"
                                                                    autocomplete="off"
                                                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                                />
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                    <div class="resend_otp">
                                                        <b-row class="justify-content-md-center">
                                                            <b-col lg="6" md="7">
                                                                <span>
                                                                    {{ this.otpResendText }} 
                                                                    <span class="resend_code" v-on:click="resendOTP">{{
                                                                        this.otpResendCode
                                                                    }}</span>
                                                                </span>
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                    <div class="continue-btn">
                                                        <b-row class="justify-content-md-center">
                                                            <b-col lg="10" md="10">
                                                                <b-button
                                                                    class="otp_continue-btn desk-margin-top"
                                                                    type="contine"
                                                                    v-on:click="onContinue"
                                                                    variant
                                                                >
                                                                    {{ this.continue }}
                                                                </b-button>
                                                                <label v-if="errorStatus" class="otp_errorMessageLabel" id="errorLabel">{{
                                                                    errorMessage
                                                                }}</label>
                                                                <label
                                                                    v-if="successStatus"
                                                                    class="otp_successMessageLabel"
                                                                    id="successLabel"
                                                                    >{{ successMessage }}</label
                                                                >
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                </b-container>
                                            </b-form>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-col>
                    </b-row>
                </b-container>
            </div>

            <Footer></Footer>
        </body>
    </html>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Footer,
    },
    data() {
        return {
            store: store,
            form: {
                iid: store.registration.iid,
                otp: "",
            },
            errorStatus: false,
            errorMessage: "",
            successStatus: false,
            successMessage: "",
            reg: /^[0-9!@#\\$%\\^\\&*\\)\\(+=._-]{4,}$/g,
        };
    },
    methods: {
        onContinue(evt) {
            evt.preventDefault();
            //TODO will be removed for Phase 3
            if (this.form.otp == "0000") {
                this.$router.push({ path: "/set_password" });
            } else if (!this.reg.test(this.form.otp)) {
                this.errorStatus = true;
                this.errorMessage = "OTP is not valid";
            } else if (this.form.otp.length == 0) {
                this.successStatus = false;
                this.errorStatus = true;
                this.errorMessage = "OTP field cannot be empty";
            } else {
                if (navigator.onLine) {
                    var header = {};

                    //     headers: [
                    //         {
                    //             key: "Content-Type",
                    //             value: "application/json",
                    //             type: "text",
                    //         },
                    //     ],
                    // };

                    apiCall
                        .apiServiceCall("Post", "", "/user/verify-otp", this.form, header)
                        .then((response) => {
                            if (response.data.status == 1) {
                                this.successStatus = false;
                                this.errorStatus = false;
                                this.$router.push({ path: "/set_password" });
                            } else {
                                this.successStatus = false;
                                this.errorStatus = true;
                                this.errorMessage = response.data.message;
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 500) {
                                this.errorStatus = true;
                                this.errorMessage = this.serverProblem;
                            } else if (error.response.status == 401) {
                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                            } else if (error.response.status == 504) {
                                this.signout();
                            } else {
                                this.successStatus = false;
                                this.errorStatus = true;
                                this.errorMessage = error.response.data.message;
                            }
                        });
                } else {
                    this.errorStatus = true;
                    this.successStatus = false;
                    this.errorMessage = this.checkInternetConnection;
                }
            }
        },
        backAction() {
            this.$router.push({ path: "/register" });
        },
        resendOTP() {
            this.errorStatus = false;
            this.successStatus = true;
            this.successMessage = "OTP sent to entered Email-ID";
            this.sendOTP();
        },
        sendOTP() {
            if (navigator.onLine) {
                var header = {};
                // var header = {
                //   headers: [
                //     {
                //       key: "Content-Type",
                //       value: "application/json",
                //       type: "text",
                //     },
                //   ],
                // };
                apiCall
                    .apiServiceCall(
                        "Post",
                        "",
                        "/user/send-otp",
                        {
                            iid: store.registration.iid,
                            eml: this.store.registration.eml,
                            mob: this.store.registration.mob,
                        },
                        header
                    )
                    .then((response) => {
                        // alert('Sent');
                        console.log("Success Block", response);
                    })
                    .catch((error) => {
                        if (error.response.status == 500) {
                            this.errorStatus = true;
                            this.errorMessage = this.serverProblem;
                        } else if (error.response.status == 401) {
                            setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                        } else if (error.response.status == 504) {
                            this.signout();
                        } else {
                            this.errorStatus = true;
                            this.errorMessage = error.response.data.message;
                        }
                    });
            } else {
                this.errorStatus = true;
                this.errorMessage = this.checkInternetConnection;
            }
        },
    },
    mounted() {
        this.sendOTP();
    },
};
</script>
